import React from "react";
import {
  BulkActionProps,
  Button,
  useNotify,
  useRefresh,
  useUnselectAll,
  useQueryWithStore,
} from "react-admin";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { useMutation } from "react-query";
import { mutateUserResendVerification } from "api/mutations/userResendVerification";
import { AdminResource } from "reactAdmin/resource/resource";

const UserResendInvitationButton: React.FC<BulkActionProps> = (props) => {
  const { selectedIds } = props;
  const { loading, data } = useQueryWithStore({
    type: "getMany",
    resource: AdminResource.users,
    payload: {
      ids: selectedIds,
    },
  });
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();

  const { mutate, isLoading } = useMutation(mutateUserResendVerification);

  const resendInvitations = async () => {
    if (Array.isArray(data)) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        if (item.activatedAt === null) {
          await mutate({ emailAddress: item.emailAddress });
        }
      }
      refresh();
      notify("Invitations sent");
      unselectAll(AdminResource.users);
    }
  };

  return (
    <Button
      label={"Resend invitation"}
      disabled={loading || isLoading}
      onClick={resendInvitations}
    >
      <MailOutlineIcon />
    </Button>
  );
};

export default UserResendInvitationButton;
